function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, Ref, RefObject, CSSProperties } from 'react';
export const LogoImageVariants = {
  default: 'default',
  icon: 'icon',
  iconApp: 'iconApp',
  textOneLine: 'textOneLine'
};
export const LogoImage = ({
  theme = 'light',
  sourceMap,
  loading = 'lazy',
  innerRef,
  controlRef,
  ...props
}) => /*#__PURE__*/React.createElement("img", _extends({
  src: theme === 'dark' ? sourceMap.dark : sourceMap.light,
  loading: loading,
  ref: innerRef || controlRef
}, props));